import { Injectable } from '@angular/core';
import { BorderlessLayout } from '../layouts/borderless-layout.model';
import { DashboardLayout } from '../layouts/dashboard-layout.model';
import { DefaultLayout } from '../layouts/default-layout.model';
import { FullLayout } from '../layouts/full-layout.model';
import { KioskLayout } from '../layouts/kiosk-layout.model';
import { Layout } from '../layouts/layout.model';
import { Layouts } from '../layouts/layouts.enum';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  public static getLayout(layout: Layouts): Layout {
    switch (layout) {
      case Layouts.FULL:
        return new FullLayout();
      case Layouts.BORDERLESS:
        return new BorderlessLayout();
      case Layouts.DASHBOARD:
        return new DashboardLayout();
      case Layouts.KIOSK:
        return new KioskLayout();
    }
    return new DefaultLayout();
  }
}
